export const filtered = ["central_reading", "clinical_trial"]

export const projectFiltered = (projectDataArray: any) => {
  return projectDataArray.filter((project: any) => {
    return filtered.includes(project.project_type)
  })
}
